import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';


@Component({
  selector: 'app-create-trip-without-order',
  templateUrl: './create-trip-without-order.component.html',
  styleUrls: ['./create-trip-without-order.component.scss']
})
export class CreateTripWithoutOrderComponent implements OnInit {

  @Output() onCloseBtnClick = new EventEmitter<any>();
  userId:any;
  CompanyId: any;

  TransportService: any = {
    lable: 'Transport Service',
    formControlName: 'TransportService',
    dataField: 'TransportService',
    isRequired: true,
    placeholder: 'Select Transport Service',
    isValueBind: true
  };

  VehicleType: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleType',
    dataField: 'VehicleType',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  PickupLocation: any = {
    lable: 'Pickup Location',
    formControlName: 'PickupLocation',
    dataField: 'PickupLocation',
    isRequired: true,
    placeholder: 'Select Pickup Location',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  DeliveryLocation: any = {
    lable: 'Delivery Location',
    formControlName: 'DeliveryLocation',
    dataField: 'DeliveryLocation',
    isRequired: true,
    placeholder: 'Select Delivery Location',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  data: any = {};
  isFormSubmitY: boolean = false;

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.GetTransportService();
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then(
    (res) => {
      this.TransportService.dropdownList = [];
      this.TransportService.dropdownList = res;
    })
    .catch((error) => {
      console.log(error);
    });
  }

  GetVehicleType(value, isScrollDown = false) {
    this.VehicleType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleType.dropdownList.length / 20) + 1;
    }
    this.orderService.GetVehicleTypeselect2(value, pageNo).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleType.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleType.dropdownList);
        this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] });
      this.VehicleType.isSearch = false;
    }).catch(error => {
      this.VehicleType.isSearch = false;
    })
  }

  GetPickupDeliveryLocationList(value, isScrollDown = false,Type) {
    this._appService.GetByTwoParam('OrdersByVehicle','GetPickupAndDeliveryLocationCodeWithoutCustomer',value,Type).subscribe(
      (response)=>{
        if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
        }

        if(Type === 'Pickup'){
          this.PickupLocation.dropdownList=[];
          // this.PickupLocation.dropdownList=response;
          this.PickupLocation = { ...this.PickupLocation, dropdownList: response };
        }else if(Type === 'Delivery'){
          this.DeliveryLocation.dropdownList=[];
          // this.DeliveryLocation.dropdownList=response;
          this.DeliveryLocation = { ...this.DeliveryLocation, dropdownList: response };
        }
      },
      (error)=>{

      }
    );
  }

  getChangedValue(value, data){
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if(value){
      if(data.dataField === 'TransportService'){
        this.data[data.dataField] = value;
      }else{
        this.data[data.dataField] = value.value;
      }
    } else{
      this.data[data.dataField] = null;
    }
  }

  Save() {
    if(!this.data.TransportService){
      this.toastr.warning('Please Select Transport Service','Warning');
      return;
    }
    if(!this.data.VehicleType){
      this.toastr.warning('Please Select Vehicle Type','Warning');
      return;
    }
    if(!this.data.PickupLocation){
      this.toastr.warning('Please Select Pickup Location','Warning');
      return;
    }
    if(!this.data.DeliveryLocation){
      this.toastr.warning('Please Select Delivery Location','Warning');
      return;
    }
    // Helpers.setLoading(true);
    this.isFormSubmitY=true;
    var obj: any = {};
    obj.UserId = this.userId;
    obj.companyId = this.CompanyId;
    obj.transportServiceId = this.data.TransportService;
    obj.vehicleTypeId = this.data.VehicleType;
    obj.pickupLocationCode = this.data.PickupLocation;
    obj.deliveryLocationCode = this.data.DeliveryLocation;
    console.log('Save obj:',obj);
    // this._appService.Post("OrdersByVehicle", "NewCreateBookingWithoutOrder", obj).subscribe(
    //   (response) => {
    //     Helpers.setLoading(false);
    //     if (response[0].Reason == "OK") {
    //       this.toastr.success(`Trip created successfully! Trip No: ${response[0].FCNumber}`,'Success');
    //     } else {
    //       this.toastr.error(response[0].Reason, "error");
    //     }
    //   },
    //   (err) => {
    //     Helpers.setLoading(false);
    //   }
    // );
  }
}
